const SET_THEME = 'scratch-gui/theme/SET_THEME';

const initialState = {
    currentTheme: 'light'
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_THEME:
        return Object.assign({}, state, {
            currentTheme: action.themeId
        });
    default:
        return state;
    }
};

const setTheme = function (themeId) {
    return {
        type: SET_THEME,
        themeId: themeId
    };
};

export {
    reducer as default,
    initialState as themeInitialState,
    setTheme
};
